import { render, staticRenderFns } from "./paymentSummary.vue?vue&type=template&id=95e24e06&"
import script from "./paymentSummary.vue?vue&type=script&lang=ts&"
export * from "./paymentSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports